class VirtualVariants extends HTMLElement {
  constructor() {
    super();
    this.variantData = JSON.parse(this.getAttribute('data-variants')) || [];
    this.selectedVariant = this.variantData[0];
    this.cartForm = document.querySelector('.product-form form');
    this.inputQuantity = null;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateDOM();
    this.listenToCartUpdates();
  }

  listenToCartUpdates() {
    // Listen for cart updates to refresh prices when discount is applied/removed
    if (typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Refresh the price section to get updated data attributes
        this.refreshPriceSection();
      });
    }
  }

  refreshPriceSection() {
    // Get the section ID from the price container
    const mixMatch = window.location.search.includes('mix_match=true');
    console.log('mixMatch: ' + mixMatch);
    if (!mixMatch) return;
    const priceContainer = document.querySelector('.price__container-pdp');
    if (!priceContainer) return;

    const sectionId = priceContainer.closest('[data-section]')?.getAttribute('data-section');
    if (!sectionId) return;

    // Fetch the updated section
    const url = `${window.location.pathname}?section_id=${sectionId}&mix_match=true`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newPriceContainer = html.querySelector('.price__container-pdp');

        if (priceContainer && newPriceContainer) {
          priceContainer.innerHTML = newPriceContainer.innerHTML;

          // Now update the prices with the current selected variant
          setTimeout(() => {
            this.updateDOM();
          }, 50);
        }
      })
      .catch((e) => {
        console.error('Error refreshing price section:', e);
      });
  }

  setupEventListeners() {
    document.querySelectorAll('.virtual-variant').forEach((button) => {
      button.addEventListener('click', (e) => {
        this.updateActiveVariant(e);
        this.updateSelectedVariant(button.getAttribute('data-variant-id'));
      });
    });
  }

  updateActiveVariant(event) {
    const selectedEl = event.currentTarget;
    const activeScheme = this.getAttribute('data-active-scheme');
    const normalScheme = this.getAttribute('data-normal-scheme');

    // Loop through all virtual variants
    this.querySelectorAll('.virtual-variant').forEach((el) => {
      // Reset: Remove active class and active color scheme
      el.classList.remove('is-active', `color-${activeScheme}`);

      // Ensure non-active variants keep the normal scheme
      el.classList.add(`color-${normalScheme}`);
    });

    // Apply active state to selected variant
    selectedEl.classList.add('is-active');
    selectedEl.classList.remove(`color-${normalScheme}`); // Remove normal scheme
    selectedEl.classList.add(`color-${activeScheme}`); // Apply active scheme
  }

  updateSelectedVariant(variantId) {
    this.selectedVariant = this.variantData.find((v) => v.id == variantId) || this.selectedVariant;
    this.updateDOM();
  }

  updateDOM() {
    this.updatePrice();
    this.updateHiddenInputs();
    this.updateLoyaltyContent();
    this.updatePricePerDay();

    document.dispatchEvent(
      new CustomEvent('virtual-variant:change', {
        detail: {
          variant: this.selectedVariant
        }
      })
    );
  }

  updatePrice() {
    const priceEl = document.querySelector(
      '.product__info-container .price__container-pdp .price__container .price__sale .price-item--sale'
    );
    const comparePriceEl = document.querySelector(
      '.product__info-container .price__container-pdp .price__container .price__sale .price-item--regular'
    );
    const unitPriceEl = document.querySelector('.unit-price.unit__price--pdp .price-item--last span:first-child');

    // Read active discounts from rendered price container attributes.
    const priceContainerDiv = document.querySelector(
      '.product__info-container .price__container-pdp .price__container'
    );
    const shouldApplyCartDiscount = priceContainerDiv?.getAttribute('data-apply-cart-discount') === 'true';
    const cartDiscountPercentage = parseFloat(priceContainerDiv?.getAttribute('data-cart-discount-percentage') || 0);
    const shouldApplyDailyDeal = priceContainerDiv?.getAttribute('data-daily-deal-active') === 'true';
    const dailyDealPercentage = parseFloat(priceContainerDiv?.getAttribute('data-daily-deal-percentage') || 0);

    // The automatic (collection-level) discount and the quantity tier discount never stack:
    // whichever is higher wins, unless a discount code is active - then the quantity tier is
    // ignored entirely and only the automatic discount applies.
    const variantQuantity = Number.parseInt(this.selectedVariant.quantity, 10) || 1;
    let basePriceString = this.selectedVariant.price;
    let baseComparePriceString = this.selectedVariant.compare_price;
    const autoDiscountPercentage = parseFloat(priceContainerDiv?.getAttribute('data-auto-discount-percentage') || 0);
    // data-discount-code-active reflects cart.discount_applications, which Shopify only
    // fills once the code is allocated against a cart line item (empty cart = always
    // false, even right after a /discount/CODE link). window.__ntActiveDiscountCode is
    // set by active-discount-price-adjustment.js as a fallback for that in-between
    // window, so the quantity tier discount still gets cancelled correctly.
    const discountCodeActive =
      priceContainerDiv?.getAttribute('data-discount-code-active') === 'true' ||
      Number(window.__ntActiveDiscountCode?.percentage) > 0;

    if (autoDiscountPercentage > 0 || discountCodeActive) {
      const tierPercentage = parseFloat(this.selectedVariant.discount_percentage || 0);
      const effectivePercentage = discountCodeActive
        ? autoDiscountPercentage
        : Math.max(autoDiscountPercentage, tierPercentage);

      // Base unit price (quantity 1, no tier discount) - same value Liquid uses for the tier math.
      const baseUnitCents = this.toCents(this.variantData[0].price);
      const discountPerUnitCents = Math.floor((baseUnitCents * effectivePercentage) / 100);
      const discountedCents = (baseUnitCents - discountPerUnitCents) * variantQuantity;
      const currencySymbol = this.variantData[0].price.match(/[€$£]/)?.[0] || '€';

      basePriceString = `${currencySymbol}${this.toMoneyFromCents(discountedCents)}`;
      // Leave baseComparePriceString as the real compare_at_price (already in
      // this.selectedVariant.compare_price) - never fabricate one from the
      // pre-discount price, matching the rule used everywhere else (cart, PLP,
      // main PDP price, quantity cards).

      const badgeEl = priceContainerDiv?.parentElement?.querySelector('.price__badge-auto-discount');
      if (badgeEl) badgeEl.textContent = `-${effectivePercentage}%`;
    }

    let displayPrice = basePriceString;
    let displayComparePrice = baseComparePriceString;
    const hasDiscount =
      (shouldApplyDailyDeal && dailyDealPercentage > 0) || (shouldApplyCartDiscount && cartDiscountPercentage > 0);

    // Apply discounts in the same order as Liquid (daily deal, then cart-level discount if present).
    if (hasDiscount) {
      let discountedCents = this.toCents(basePriceString);

      if (shouldApplyDailyDeal && dailyDealPercentage > 0) {
        discountedCents = this.applyDailyDiscountCents(discountedCents, dailyDealPercentage, variantQuantity);
      }

      if (shouldApplyCartDiscount && cartDiscountPercentage > 0) {
        // Keep default/cart discount behavior unchanged (standard rounding).
        discountedCents = Math.round((discountedCents * (100 - cartDiscountPercentage)) / 100);
      }

      // Format back to currency string (assuming Euro format)
      const currencySymbol = basePriceString.match(/[€$£]/)?.[0] || '€';
      displayPrice = `${currencySymbol}${this.toMoneyFromCents(discountedCents)}`;

      // Show original as compare price when discount is active.
      displayComparePrice = basePriceString;
    }

    if (priceEl) priceEl.innerHTML = displayPrice;
    if (comparePriceEl && displayComparePrice) comparePriceEl.innerHTML = displayComparePrice;
    if (unitPriceEl) unitPriceEl.innerHTML = this.selectedVariant.unit_price;
  }

  updateHiddenInputs() {
    document.querySelectorAll('input[name="quantity"][type="hidden"]').forEach((input) => {
      input.value = this.selectedVariant.quantity;
    });

    if (!this.inputQuantity) {
      this.inputQuantity = document.createElement('input');
      this.inputQuantity.setAttribute('id', 'quantity');
      this.inputQuantity.setAttribute('name', 'quantity');
      this.inputQuantity.setAttribute('type', 'hidden');
      this.cartForm.appendChild(this.inputQuantity);
    }
    this.inputQuantity.setAttribute('value', this.selectedVariant.quantity);
  }

  updateLoyaltyContent() {
    const baseUnitEl = document.querySelector('.loyalty-content .base-unit .value');
    const durationEl = document.querySelector('.loyalty-content .duration .value');
    //const pointsEl = document.querySelector('.loyalty-content .points .value'); removed due to loyalty lion

    if (baseUnitEl) {
      baseUnitEl.innerHTML = `${this.selectedVariant.quantity} x ${this.getAttribute('data-base-unit')}`;
    }

    /* removed due to loyalty lion
    const priceNumber = parseFloat(this.selectedVariant.price.replace(/\D/g, '')) / 100;
    if (pointsEl) {
      console.log('priceNumber: ' + priceNumber);
      pointsEl.innerHTML = `${Math.floor(priceNumber) * 5} Punkte`;
    }
    */

    const durationMonth = this.selectedVariant.quantity * parseFloat(this.getAttribute('data-duration'));
    if (durationEl) {
      durationEl.innerHTML = `${durationMonth} ${durationMonth > 1 ? 'Monate' : 'Monat'}`;
    }
  }
  updatePricePerDay() {
    const pricePerDayEl = document.querySelector('.ac-price-tooltip');
    if (!pricePerDayEl) return;

    // Get dosage amount and capsules amount from data attributes
    const dosageAmount = parseFloat(pricePerDayEl.dataset.dosageAmount);
    const capsuleAmount = parseFloat(pricePerDayEl.dataset.capsulesAmount);

    if (!dosageAmount || !capsuleAmount) return;

    // Work in cents to avoid float drift and keep 2-digit precision.
    const variantQuantity = Number.parseInt(this.selectedVariant.quantity, 10) || 1;

    // Read active discounts from rendered price container attributes.
    const priceContainerDiv = document.querySelector(
      '.product__info-container .price__container-pdp .price__container'
    );
    const shouldApplyCartDiscount = priceContainerDiv?.getAttribute('data-apply-cart-discount') === 'true';
    const cartDiscountPercentage = parseFloat(priceContainerDiv?.getAttribute('data-cart-discount-percentage') || 0);
    const shouldApplyDailyDeal = priceContainerDiv?.getAttribute('data-daily-deal-active') === 'true';
    const dailyDealPercentage = parseFloat(priceContainerDiv?.getAttribute('data-daily-deal-percentage') || 0);

    // Same auto-discount-vs-quantity-tier resolution as updatePrice(): whichever is higher wins
    // (no stacking), and a discount code, if active, cancels the quantity tier entirely.
    const autoDiscountPercentage = parseFloat(priceContainerDiv?.getAttribute('data-auto-discount-percentage') || 0);
    let priceCents;

    if (autoDiscountPercentage > 0) {
      const discountCodeActive = priceContainerDiv?.getAttribute('data-discount-code-active') === 'true';
      const tierPercentage = parseFloat(this.selectedVariant.discount_percentage || 0);
      const effectivePercentage = discountCodeActive
        ? autoDiscountPercentage
        : Math.max(autoDiscountPercentage, tierPercentage);

      const baseUnitCents = this.toCents(this.variantData[0].price);
      const discountPerUnitCents = Math.floor((baseUnitCents * effectivePercentage) / 100);
      priceCents = (baseUnitCents - discountPerUnitCents) * variantQuantity;
    } else {
      priceCents = this.toCents(this.selectedVariant.price);
    }

    // Apply discounts in the same order as Liquid (daily deal, then cart-level discount if present).
    if (shouldApplyDailyDeal && dailyDealPercentage > 0) {
      priceCents = this.applyDailyDiscountCents(priceCents, dailyDealPercentage, variantQuantity);
    }

    if (shouldApplyCartDiscount && cartDiscountPercentage > 0) {
      priceCents = Math.round((priceCents * (100 - cartDiscountPercentage)) / 100);
    }

    // Calculate total capsules based on quantity
    const totalCapsules = capsuleAmount * this.selectedVariant.quantity;

    // Calculate days supply and price per day
    const daysSupply = totalCapsules / dosageAmount;
    const pricePerDay = (priceCents / 100) / daysSupply;

    // Format price to 2 decimal places
    const formattedPrice = pricePerDay.toFixed(2);

    const useStaticText = shouldApplyDailyDeal && pricePerDayEl.dataset.pricePerDayText;
    let finalText = '';

    if (useStaticText) {
      // Daily deal PDP text uses __DISCOUNT__ and should stay fixed on variant switches.
      finalText = pricePerDayEl.dataset.pricePerDayText;
    } else {
      // Default behavior: replace __PRICE__ in section template.
      const textTemplate = pricePerDayEl.dataset.text;
      finalText = textTemplate.replace(
        '__PRICE__',
        `${pricePerDayEl.dataset.currency}${formattedPrice.replace('.', ',')}`
      );
    }

    // Update the text content
    const textElement = pricePerDayEl.querySelector('.text');
    if (textElement) {
      textElement.textContent = finalText;
    }
  }

  toCents(moneyString) {
    const normalized = (moneyString || '').replace(/[^0-9,.-]/g, '').replace(',', '.');
    const amount = Number.parseFloat(normalized);
    if (Number.isNaN(amount)) return 0;
    return Math.round(amount * 100);
  }

  toMoneyFromCents(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  applyDailyDiscountCents(baseCents, dailyDealPercentage, quantity) {
    if (!quantity || quantity <= 1) {
      return Math.ceil((baseCents * (100 - dailyDealPercentage)) / 100);
    }

    // For multi-pack virtual variants, round per unit first (matches checkout allocations), then multiply.
    const unitCents = Math.round(baseCents / quantity);
    const discountedUnitCents = Math.ceil((unitCents * (100 - dailyDealPercentage)) / 100);
    return discountedUnitCents * quantity;
  }
}

customElements.define('virtual-variants', VirtualVariants);
